<!--
2023-06-02 ytw
-->
<template>
  <div class="pop-confirm">
    <div class="white-content" @click="closeRecord"></div>
    <div class="background-content">
      <div class="title">{{ $t('lang.betActivityRegularly.records') }}</div>
      <div class="bigBox">
        <div class="selectTools">
          <div class="tool-box">
            <div class="selector" @click="typeSelect">
              <span>{{ typeShow.name }}</span>
              <img :src="triangle" class="triangleImage" alt=""/>
            </div>
            <div class="selectList" v-if="showTypeSelect">
              <div class="option"
                   :class="{'selectActive':typeShow.key === item.key}"
                   v-for="(item, index) in typeList"
                   :key="index" @click="selectType(item)">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div class="tool-box">
            <div class="selector" @click="dateSelect">
              <span>{{ dateShow.name }}</span>
              <img :src="triangle" class="triangleImage" alt=""/>
            </div>
            <div class="selectList" v-if="showDateSelect">
              <div class="option"
                   :class="{'selectActive':dateShow.key === item.key}"
                   v-for="(item, index) in dateList"
                   :key="index" @click="selectDateSpan(item)">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="masks" @click="noShowSelect" v-if="showTypeSelect"/>
      <div class="masks" @click="noShowSelect" v-if="showDateSelect"/>
      <div class="gift-list">
        <Loadmore :bottomPullText="''"
                  :bottomDropText="''"
                  :bottomLoadingText="''"
                  :auto-fill="false"
                  :bottom-method="fetchGiftList"
                  :bottom-all-loaded="allLoaded"
                  ref="loadmore">
          <div class="gift-row" v-for="(item, index) in giftList" :key="index">
            <div class="content-box">
              <div class="dueDate">
                {{ item.DueDate }}
              </div>
              <div class="type-content">
                <div class="imageOuter">
                <img :src="coin" v-if="item.GiftType==='gift'" alt="coin">
                <img :src="card" v-if="item.GiftType==='discount'" alt="card" style="rotate: -5deg">
                </div>
                <div class="gift-text" v-if="item.GiftType==='gift'">
                  <div class="text-right">+{{ $t('lang.account.currencyType') }}{{ item.GiftAmount }}</div>
                </div>
                <div class="gift-text" v-if="item.GiftType==='discount'">
                  <div class="text-right">{{ $t('lang.luckyWheel.deposit') }} +{{ item.Discount }}%</div>
                </div>
              </div>
            </div>
            <div class="btn-box">
              <div class="use" v-if="item.Status===10" @click="toDeposit(item)">{{ $t('lang.luckyWheel.use') }}</div>
              <div class="received" v-if="(item.Status===20||item.Status===30)&&item.GiftType==='gift'">{{ $t('lang.luckyWheel.received') }}</div>
              <div class="done" v-if="(item.Status===20||item.Status===30)&&item.GiftType==='discount'">{{ $t('lang.luckyWheel.used') }}</div>
              <div class="done" v-if="item.Status===40&&item.GiftType==='discount'">{{ $t('lang.luckyWheel.expire') }}</div>
            </div>
          </div>
          <div class="showMore" v-if="!allLoaded"><img :src="showMore" alt=""></div>
        </Loadmore>
      </div>
    </div>
  </div>
</template>
<script>
import {Loadmore} from 'mint-ui'
import triangle from '@/assets/images/wheel/triangle.png'
import coin from '@/assets/images/wheel/coin.png'
import card from '@/assets/images/wheel/card.png'
import showMore from '@/assets/images/common/showMore.gif'
import request from '@/service'

export default {
  name: 'wheelRecord',
  props: [
    'closeRecord',
    'showRecord',
    'closeAll',
    'wheelId',
    'userInfo'
  ],
  components: {
    Loadmore
  },
  data () {
    return {
      triangle,
      coin,
      card,
      showMore,
      showTypeSelect: false,
      showDateSelect: false,
      typeList: [],
      dateList: [],
      giftList: [],
      allLoaded: true,
      firstLoad: true,
      typeShow: {},
      dateShow: {},
      pageNumber: -1
    }
  },
  watch: {
    showRecord (n, o) {
      if (n) {
        this.noShowSelect()
        this.giftList = []
        this.pageNumber = -1
        this.allLoaded = true
        this.firstLoad = true
        this.fetchGiftList()
      }
    }
  },
  mounted () {
    this.typeList = this.$t('lang.luckyWheel.typeList')
    this.dateList = this.$t('lang.luckyWheel.dateList')
    this.typeShow = this.typeList[0]
    this.dateShow = this.dateList[0]
  },
  methods: {
    fetchGiftList () {
      if (!this.userInfo) {
        return
      }
      this.pageNumber++
      const url = '/innovation/luckywheel/get_records'
      let data = {
        Days: this.dateShow.key,
        GiftType: this.typeShow.key,
        UserId: this.userInfo.UserId,
        WheelId: this.wheelId,
        PageNumber: this.pageNumber
      }
      request('post', url, data).then(result => {
        if (result && result !== -1) {
          this.giftList = this.giftList.concat(result)
          this.allLoaded = result.length < 10
          if (!this.firstLoad) {
            this.$refs.loadmore.onBottomLoaded()
          }
          this.firstLoad = false
        }
      })
    },
    toDeposit (item) {
      this.closeAll()
      this.$router.push({name: 'Deposit', query: {guid: item.GiftUuid}}) // 告知充值页面使用充值赠券
    },
    typeSelect () {
      this.showTypeSelect = !this.showTypeSelect
    },
    dateSelect () {
      this.showDateSelect = !this.showDateSelect
    },
    selectType (item) {
      this.noShowSelect()
      this.giftList = []
      this.typeShow = item
      this.pageNumber = -1
      this.allLoaded = true
      this.firstLoad = true
      this.fetchGiftList()
    },
    selectDateSpan (item) {
      this.noShowSelect()
      this.giftList = []
      this.dateShow = item
      this.pageNumber = -1
      this.allLoaded = true
      this.firstLoad = true
      this.fetchGiftList()
    },
    noShowSelect () {
      this.showTypeSelect = false
      this.showDateSelect = false
    }
  }
}
</script>

<style lang="less" scoped>
.pop-confirm {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, .6);
  z-index: 990;
  padding: 11.111vw 5.556vw;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  flex-flow: column;

  .white-content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgb(0, 0, 0 0.7);
  }

  .background-content {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 86.667vw;
    height: 125.555vw;
    background: #181818;
    border-radius: 2.222vw;

    .title {
      margin-top: 2.9vw;
      font-family: Inter;
      font-size: 6.388vw;
      font-weight: 700;
      text-align: center;
      color: #FFFFFF;
      height: 12vw;
      border-bottom: 0.14vw solid #4E4D4D
    }
    .masks {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0);
      z-index: 9;
      .type-container {
        position: absolute;
        top: 0;
        left: 0;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        height: max-content;
        min-width: max-content;
        .selectList {
          height: max-content;
          text-align: left;
          z-index: 5;
          .option {
            white-space: nowrap;
            padding: 1px 10px;
            margin: 5px 0;
            display: flex;
            width: max-content;
            font-size: 18px;
            font-weight: 700;
            line-height: 26px;
            div {
              width: 100%;
              height: 30px;
            }
          }
          .selectactive {
            color: #fff;
          }
        }
      }
      .date-container {
        position: absolute;
        top: 0;
        left: 0;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        height: max-content;
        min-width: max-content;
        .selectList {
          height: max-content;
          padding: 2px 0;
          text-align: left;
          z-index: 5;
          .option {
            white-space: nowrap;
            padding: 1px 10px;
            margin: 5px 0;
            display: flex;
            width: max-content;
            font-size: 18px;
            font-weight: 700;
            line-height: 26px;
            div {
              width: 100%;
              height: 30px;
            }
          }
          .selectactive {
            color: #fff;
          }
        }
      }
    }
    .bigBox {
      display: flex;
      margin: 3.75vw auto 0 auto;
      text-align: left;
      z-index: 10;

      .selectTools {
        margin-left: 4.57vw;
        display: flex;
        height: 7.777vw;

        span {
          margin-left: 4.166VW;
          white-space: nowrap;
          font-family: Inter;
          font-size: 3.611vw;
          font-weight: 500;
          line-height: 7.777vw;
          text-align: center;
        }

        .tool-box {
          position: relative;
          width: 27.367vw;
          height: 7.777vw;
          margin-right: 1.95vw;
          z-index: 10;

          .selector {
            position: relative;
            width: 100%;
            height: 100%;
            line-height: 7.777vw;
            border-radius: 2.222vw;
            background: #292929;
            color: #FFFFFF;
            z-index: 5;
          }

          .triangleImage {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 2.5vw;
            width: 4.225vw;
            height: 3.169vw;
            z-index: 1;
          }

          .selectList {
            position: absolute;
            top: 9.5vw;
            left: 0;
            width: 27.222vw;
            height: max-content;
            text-align: left;
            background: #3B3B3B;
            border-radius: 2.222vw;
            z-index: 0;

            .option {
              font-family: Inter;
              white-space: nowrap;
              display: flex;
              font-size: 3.611vw;
              font-weight: 500;
              text-align: center;
              line-height: 7.222vw;
              padding-left: 2.222vw;
              color: #FFFFFF;
            }

            .selectActive {
              background: #CAB897;
              border-radius: 2.222vw;
              color: #000000;
            }
          }
        }
      }
    }

    .gift-list {
      margin: 5.555vw auto 0 auto;
      width: 90%;
      height: 88vw;
      overflow-x: hidden;
      overflow-y: auto;

      .gift-row {
        display: flex;
        justify-content: space-between;
        width: 76.667vw;
        height: 14.722vw;
        border-radius: 2.222vw;
        background: #272727;
        margin-bottom: 3.333vw;
        padding-right: 3.05vw;

        .content-box {
          width: 31.111vw;

          .type-content {
            display: flex;
            height: 5.8333vw;
            margin-top: 1.388vw;

            .imageOuter {
              display: flex;
              justify-content: center;
              width: 8.1vw;
              margin: 0 2.45vw;

              img {
                height: 5.8333vw;
                width: auto;
              }
            }

            .gift-text {
              display: flex;
              white-space: nowrap;
              font-family: Inter;
              font-size: 3.888vw;
              font-weight: 500;
              text-align: center;
              color: #F1DAB0;
              margin-top: 0.5vw;

              .text-right {
                width: max-content;
                text-align: right;
              }
            }
          }

          .dueDate {
            margin-left: 2.5vw;
            margin-top: 1.694vw;
            font-family: Inter;
            font-size: 3.055vw;
            font-weight: 500;
            text-align: left;
            color: #6F6F6F;
          }
        }

        .btn-box {
          width: 22.5vw;

          div {
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            text-align: center;
            width: 100%;
            height: 6.388vw;
            line-height: 6.388vw;
            font-family: Inter;
            font-size: 2.778vw;
            font-weight: 600;
            border-radius: 1.111vw;
          }

          .use {
            background: #F1DAB0;
            color: #000000;
          }

          .received {
            border: 0.2777vw solid #F1DAB0;
            color: #F1DAB0;
          }

          .done {
            border: 0.2777vw solid #575757;
            color: #878787;
          }
        }
      }
    }

    .gift-list::-webkit-scrollbar {
      display: none;
    }

    .showMore {
      text-align: center;

      img {
        width: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Wheel/record.vue